<template>
	<div class="BaseProductsTable">
		<!-- <div class="table-sns">
      <h3>
        Upload Stock Count
      </h3>
      <a
        class="cursor-pointer"
      >
        Export Count
      </a>
    </div> -->
		<simplebar class="simplebar">
			<table class="tableMain">
				<thead>
					<tr>
						<th v-if="isEdit" colspan="1" class="border-right">
							Edit
						</th>
						<th colspan="1" class="border-right">
							Delete
						</th>
						<th colspan="1" class="border-right">
							Item Name
						</th>
						<th colspan="1" class="border-right">
							Item Code
						</th>
						<th colspan="1" class="border-right">
							Item Type
						</th>
						<th colspan="1" class="border-right">
							Order Unit
						</th>
						<th colspan="1" class="border-right">
							Contains
						</th>
						<th colspan="1" class="border-right">
							Base Unit
						</th>
						<th
							v-if="showExternalSupplierFields"
							colspan="1"
							class="border-right"
						>
							Order Unit Cost
						</th>
						<th
							v-if="showExternalSupplierFields"
							colspan="1"
							class="border-right"
						>
							Base Unit Cost
						</th>
						<th
							v-if="showExternalSupplierFields"
							colspan="1"
							class="border-right"
						>
							Weightable
						</th>
						<th
							v-if="showExternalSupplierFields"
							colspan="1"
							class="border-right"
						>
							Minimum Order
						</th>
						<th
							v-if="showExternalSupplierFields"
							colspan="1"
							class="border-right"
						>
							Deposit If Any
						</th>
						<th
							v-if="showExternalSupplierFields"
							colspan="1"
							class="border-right"
						>
							Tax
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(product, productIndex) in products" :key="product.id">
						<td v-if="isEdit">
							<BaseButton
								buttonclass="btn py-1.5 px-4 text-sm"
								@click="$emit('editArticle', productIndex)"
							>
								Edit
							</BaseButton>
						</td>
						<td>
							<BaseButton
								buttonclass="btn py-1.5 px-4 text-sm"
								@click="$emit('deleteArticle', productIndex)"
							>
								Delete
							</BaseButton>
						</td>
						<td>
							<el-select
								v-model="product.itemName"
								v-validate="showTable ? 'required' : ''"
								filterable
								:name="`Item Name + ${product.id}`"
								style="min-width: 200px;"
								placeholder="Item Name"
								@change="getArticle($event, productIndex)"
							>
								<el-option
									v-for="(article, articleIndex) in articles"
									:key="articleIndex"
									:label="article.name"
									:value="article.id"
								/>
							</el-select>
							<span
								:v-show="errors.has(`Item Name + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Item Name + ${product.id}`) }}
							</span>
						</td>
						<td>
							<BaseInput
								v-model="product.itemCode"
								style="min-width: 200px;"
								class="baseInput"
								disabled
								custom-class="p-2 text-sm text-amp-input-boxes"
								placeholder="code"
							/>
						</td>
						<td>
							<BaseInput
								v-model="product.itemType"
								style="min-width: 200px;"
								class="baseInput"
								disabled
								custom-class="p-2 text-sm text-amp-input-boxes"
								placeholder="Ingredient Type"
							/>
						</td>
						<td>
							<BaseInput
								v-model="product.orderUnit"
								v-validate="showTable ? 'required' : ''"
								style="min-width: 150px;"
								class="baseInput"
								:name="`Order Unit + ${product.id}`"
								custom-class="p-2 text-sm text-amp-input-boxes"
								placehoder="Order Unit"
							/>
							<span
								:v-show="errors.has(`Order Unit + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Order Unit + ${product.id}`) }}
							</span>
						</td>
						<td>
							<BaseInput
								v-model="product.contains"
								v-validate="showTable ? 'required' : ''"
								style="min-width: 100px;"
								class="baseInput"
								:name="`Contains + ${product.id}`"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Contains"
							/>
							<span
								:v-show="errors.has(`Contains + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Contains + ${product.id}`) }}
							</span>
						</td>
						<td>
							<BaseInput
								v-model="product.baseUnit"
								style="min-width: 100px;"
								class="baseInput"
								disabled
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Base Unit"
							/>
						</td>
						<td v-if="showExternalSupplierFields">
							<BaseInput
								v-model="product.orderUnitCost"
								v-validate="showTable ? 'required|numeric' : ''"
								class="baseInput"
								style="min-width: 100px;"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Order Unit Cost"
								:name="`Order Unit Cost + ${product.id}`"
							/>
							<span
								:v-show="errors.has(`Order Unit Cost + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Order Unit Cost + ${product.id}`) }}
							</span>
						</td>
						<td v-if="showExternalSupplierFields">
							<BaseInput
								v-model="product.baseUnitCost"
								v-validate="showTable ? 'required|decimal' : ''"
								style="min-width: 100px;"
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Base Unit Cost"
								:name="`Base Unit Cost + ${product.id}`"
							/>
							<span
								:v-show="errors.has(`Base Unit Cost + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Base Unit Cost + ${product.id}`) }}
							</span>
						</td>
						<td v-if="showExternalSupplierFields">
							<el-select
								v-model="product.weightable"
								v-validate="showTable ? 'required' : ''"
								style="min-width: 100px;"
								placeholder="Weightable"
								:name="`Weightable + ${product.id}`"
							>
								<el-option label="Yes" :value="true" />
								<el-option label="No" :value="false" />
							</el-select>
							<span
								:v-show="errors.has(`Weightable + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Weightable + ${product.id}`) }}
							</span>
						</td>
						<td v-if="showExternalSupplierFields">
							<BaseInput
								v-model="product.minimumOrder"
								v-validate="showTable ? 'required|numeric' : ''"
								style="min-width: 100px;"
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Minimum Order"
								:name="`Minimum Order + ${product.id}`"
							/>
							<span
								:v-show="errors.has(`Minimum Order + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Minimum Order + ${product.id}`) }}
							</span>
						</td>
						<td v-if="showExternalSupplierFields">
							<BaseInput
								v-model="product.deposit"
								v-validate="showTable ? 'required|numeric' : ''"
								style="min-width: 100px;"
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Deposit"
								:name="`Deposit + ${product.id}`"
							/>
							<!-- <span
								:v-show="errors.has(`Deposit + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Deposit + ${product.id}`) }}
							</span> -->
						</td>
						<td v-if="showExternalSupplierFields">
							<BaseInput
								v-model="product.tax"
								v-validate="showTable ? 'required|decimal' : ''"
								style="min-width: 100px;"
								class="baseInput"
								custom-class="p-2 text-sm  text-amp-input-boxes"
								placeholder="Tax"
								:name="`Tax + ${product.id}`"
							/>
							<span
								:v-show="errors.has(`Tax + ${product.id}`)"
								class="text-red-dark text-xs"
							>
								{{ errors.first(`Tax + ${product.id}`) }}
							</span>
						</td>
					</tr>
				</tbody>
			</table>
		</simplebar>
		<div class="">
			<el-row :gutter="20">
				<el-col
					v-if="isAddProductButton"
					:xl="6"
					:lg="6"
					:md="6"
					:sm="6"
					:xs="24"
				>
					<div class="mt-4 text-center">
						<BaseButton
							class="mt-4"
							buttonclass="btn py-1.5 px-4 text-sm"
							@click="products.push(addToProducts())"
						>
							Add Product
						</BaseButton>
					</div>
				</el-col>
				<el-col :xl="6" :lg="6" :md="6" :sm="6" :xs="24">
					<slot name="saveButton"> </slot>
					<!-- <div class="mt-4">
						<el-pagination
							background
							:page-sizes="[5, 10, 15]"
							layout="sizes, prev, pager, next"
						/>
					</div> -->
				</el-col>
			</el-row>

			<!-- <div class=" flex justify-between items-center p-2 pr-4">
        <div v-if="isAddProductButton">
          <BaseButton
            class="mr-8"
            buttonclass="btn py-1.5 px-4 text-sm"
            @click="addProductsArr.push('lab')"
          >
            Add Product
          </BaseButton>
        </div>
        <div class="flex ml-auto items-center">
          <BaseButton
            class="mr-8"
            buttonclass="btn py-1.5 px-4 text-sm"
          >
            Save
          </BaseButton>
          <div>
            <el-pagination
              background
              :page-sizes="[5, 10, 15]"
              layout="sizes, prev, pager, next"
            />
          </div>
        </div>
      </div> -->
		</div>
	</div>
</template>

<script>
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
import InventoryService from "../../services/inventoryService";
import { CommonMixin } from "../../../mixins/common.mixin";
import { async, resolve } from "q";
const articleFields = ["base_unit", "code", "order_unit", "type", "id", "name"];
export default {
	name: "BaseAddProductsTable",
	components: {
		simplebar
	},
	mixins: [CommonMixin],
	inject: ["$validator"],
	props: {
		isAddProductButton: {
			type: Boolean,
			default: false
		},
		products: {
			type: Array,
			default: () => []
		},
		showTable: {
			// only validate if not uploading csv
			type: Boolean,
			default: false
		},
		showExternalSupplierFields: {
			type: Boolean,
			default: false
		},
		isEdit: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			// isAddProductButton: true,
			productId: 0,
			// route: "",
			articles: []
		};
	},
	created() {
		if (!this.products.length) {
			this.products.push(this.addToProducts());
		}
		// this.route = this.$route.name;

		this.getArticles({ get_all: true });
	},
	updated() {
		if (!this.products.length) {
			this.products.push(this.addToProducts());
		}
	},
	methods: {
		async getArticles(args) {
			try {
				this.articles = await InventoryService.getArticles(args).then(
					response => resolve(JSON.parse(response.data))
				);
			} catch (err) {
				console.log(err);
			}
		},
		async getArticle(articleId, index) {
			await InventoryService.getArticle({
				ingredientId: articleId,
				fields: articleFields
			}).then(response => {
				// console.log("response in getArticle", JSON.parse(response.data));
				const article = JSON.parse(response.data);
				this.products[index].itemCode = article.code;
				this.products[index].itemType = article.type;
				this.products[index].baseUnit = article.base_unit;
			});
		},
		addToProducts() {
			this.productId = this.productId + 1;
			return {
				itemName: "",
				itemCode: "",
				itemType: "",
				orderUnit: "",
				contains: "",
				baseUnit: "",
				orderUnitCost: "",
				baseUnitCost: "",
				weightable: "",
				minimumOrder: "",
				deposit: "",
				tax: "",
				id: this.productId
			};
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./BaseProductsTable.scss";
</style>

<style lang="scss">
.AppLayout .el-select .el-input.is-focus .el-input__inner {
	overflow: scroll;
}
.tableMain .el-input__inner {
	font-size: 12px;
}
</style>

